// extracted by mini-css-extract-plugin
module.exports = {"notes":"BookingEngineConfigDetailsCard_notes__2wcEX","notesText":"BookingEngineConfigDetailsCard_notesText__3pl76"};